import {UserSearch} from "../../core/url/services/RedirectToUserSearch";
import location from "../../../../common/ts/core/location";
import {EventBus} from "../../../../common/ts/events/EventBus";
import {SelectChangeEvent} from "../../../../common/ts/events/Events";
import {TrovitSerpData, TrovitSerpDataImpl} from "../TrovitPageData";
import TrackFilterWithGoogleAnalyticsService, {
    TrackFilterWithGoogleAnalyticsData
} from "../services/TrackFilterWithGoogleAnalyticsService";
import TrackFiltersWebTrackingEventsService from "../services/TrackFiltersWebTrackingEventsService";
import {FILTER_NAMES} from "../../../../common/ts/serp/filters/constants";

export default class PriceRangeSelectorSubscriber {

    private readonly eventBus: EventBus
    private readonly userSearch: UserSearch
    private readonly trackFilterWithGoogleAnalyticsService: TrackFilterWithGoogleAnalyticsService
    private readonly trackFiltersWebTrackingEventsService: TrackFiltersWebTrackingEventsService

    constructor(
        eventBus: EventBus,
        userSearch: UserSearch,
        trackFilterWithGoogleAnalyticsService: TrackFilterWithGoogleAnalyticsService,
        trackFiltersWebTrackingEventsService: TrackFiltersWebTrackingEventsService
    ) {
        this.eventBus = eventBus
        this.userSearch = userSearch
        this.trackFilterWithGoogleAnalyticsService = trackFilterWithGoogleAnalyticsService
        this.trackFiltersWebTrackingEventsService = trackFiltersWebTrackingEventsService
    }

    init(pageData: TrovitSerpData) {
        this.eventBus.subscribeWithId(SelectChangeEvent.TYPE, {
            id: 'trovit-serp-price-range-selector-changed-subscriber',
            callback: (event) => {
                const {payload}: SelectChangeEvent = event as SelectChangeEvent;

                if (payload.id === "price-min-selector" || payload.id === "price-max-selector") {
                    this.trackFilterWithGoogleAnalyticsService.execute({
                        value: 'price',
                        isSem: pageData.isSem,
                    } as TrackFilterWithGoogleAnalyticsData);
                    const filterProperty = this.filterMapping[payload.id];
                    if (!filterProperty) return;
                    pageData[filterProperty] = payload.value;
                    const userSearchFilters = TrovitSerpDataImpl.createWithDefaults(
                        pageData,
                        location.getOrigin()
                    ).toTrovitUserSearchUrlParams();
                    this.userSearch.execute({
                        ...userSearchFilters,
                        [filterProperty]: payload.value
                    });
                    this.trackFiltersWebTrackingEventsService.execute({
                        filter: this.toStandardFilterName[filterProperty],
                        value:payload.value,
                    });
                }
            }
        });
    }

    private get filterMapping(): { [key: string]: string } {
        return {
            "price-min-selector": 'priceMin',
            "price-max-selector": 'priceMax'
        };
    }

    private get toStandardFilterName(): { [key: string]: string } {
        return {
            "priceMin": FILTER_NAMES.MIN_PRICE,
            "priceMax": FILTER_NAMES.MAX_PRICE
        };
    }

}